export const formatTimecode = (timeInSeconds: number, fps: number): string => {
    if (!timeInSeconds || isNaN(timeInSeconds) || !fps) return '00:00:00:00';

    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);

    const frames = Math.floor((timeInSeconds % 1) * fps);

    const pad = (num: number) => String(num).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}:${pad(frames)}`;
};
